/**
 * ClosedArea — public entry point for the board's collapsed Closed area
 * (SE-5496). Exposes the Container, which owns collapse + reopen-dialog state.
 * @module features/player-kanban/components/organisms/ClosedArea
 */

export { default } from "./ClosedAreaContainer";
export type { ClosedAreaContainerProps } from "./ClosedAreaContainer";
